import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=1a67f1a9"
import script from "./UserSelect.ts?vue&type=script&lang=ts&external"
export * from "./UserSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports